import { system, Config } from "styled-system"

const configs: Config = {
	overflowWrap: {
		property: "overflowWrap"
	}
}

export const overflowWrap = system(configs)
